import { applyFilters, doRequest } from "./helpers";

export default class MetaPixelStatService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/pixel_stats`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
